import { EventLogMessageResponse } from '../dto/response/event-log-message-response';
import { EventLogMessageResponseEventLogActionEnum } from '../event-log-message-response-event-log-action-enum';
import { EventLogMessageResponseEventLogContextTypeEnum } from '../event-log-message-response-event-log-context-type-enum';
import { BaseLandscapeService } from '../../../landscapeAPI/base-landscape.service';

class EventLoggingService extends BaseLandscapeService {
  public async fetchEventLogs(): Promise<EventLogMessageResponse> {
    const response = await this.get<EventLogMessageResponse>(`/events`);
    return response.data;
  }

  public async fetchFilteredEventLogsService(
    action: string | undefined,
    context: string | undefined,
    search: string | undefined,
    fromDate: string | undefined,
    toDate: string | undefined
  ): Promise<EventLogMessageResponse> {
    const response = await this.get<EventLogMessageResponse>(`/events/`, {
      params: {
        eventAction: action,
        context: context,
        search: search,
        fromDate: fromDate,
        toDate: toDate,
      },
    });

    return response.data;
  }

  public async fetchEventLogsByContextType(
    contextType: EventLogMessageResponseEventLogContextTypeEnum
  ): Promise<EventLogMessageResponse> {
    const response = await this.get<EventLogMessageResponse>(
      `/events/geteventsbyentitytype/${contextType}`
    );
    return response.data;
  }

  public async fetchEventLogsByAction(
    action: EventLogMessageResponseEventLogActionEnum
  ): Promise<EventLogMessageResponse> {
    const response = await this.get<EventLogMessageResponse>(
      `/events/geteventsbyeventlogaction`,
      {
        params: {
          action: action,
        },
      }
    );
    return response.data;
  }
}

const eventLoggingService = new EventLoggingService();
export default eventLoggingService;
